import { Checkbox, FormControlLabel, FormControlLabelProps } from '@mui/material';
import { ReactNode } from 'react';
import { Field } from 'react-final-form';

export type CheckboxProps = {
  name: string;
  label: ReactNode;
  value?: string;
  disabled?: boolean;
  formControlLabelProps?: Partial<FormControlLabelProps>;
};

export const CheckboxField = (props: CheckboxProps) => {
  const { name, value, label, disabled, formControlLabelProps } = props;

  return (
    <Field
      name={name}
      type="checkbox"
      value={value}
      render={({ input }) => (
        <FormControlLabel
          control={<Checkbox {...input} />}
          label={label}
          disabled={disabled}
          {...formControlLabelProps}
        />
      )}
    />
  );
};
